/**
 * Generic route error message string
 */
export default class RouteError {
    message: string;

    constructor(message: string) {
        this.message = message
    }
}